import { FC, useMemo } from 'react';
import { useTranslation } from 'next-i18next';

import { AssetsForms } from '@/entities/assets';
import { AssetCategory } from '@/shared/lib/sj-orm/models/asset.dto';

type AssetTypeValueProps = {
  assetInfo: {
    category: AssetCategory;
    type: unknown;
  };
};

export const AssetTypeValue: FC<AssetTypeValueProps> = ({ assetInfo }) => {
  const { t } = useTranslation(['form_assets']);

  const typeValue = useMemo(() => {
    const { category, type } = assetInfo;

    if (!category || !type) {
      return null;
    }

    const fields = AssetsForms[category]?.reduce((acc, cur) => {
      Object.assign(acc, cur);
      return acc;
    }, {});

    const fieldType = fields?.type;
    if (!fieldType) {
      return null;
    } else {
      // @ts-ignore
      const typeItem = fieldType.items.find((iItem) => iItem.key === type);
      const i18nKey = typeItem?.label;

      return t(i18nKey);
    }
  }, [assetInfo]);

  return <>{typeValue}</>;
};
